export const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '-';
  
  return date.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
};

export const formatINR = (amount) => {
  const n = Number(amount) || 0;
  return `₹${n.toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;
};

// Maps a workflow status to a badge CSS class (defined in App.css).
export const statusBadgeClass = (status) => {
  switch (status) {
    case 'approved':
    case 'accepted':
    case 'paid':
    case 'verified':
    case 'valid':
    case 'active':
    case 'excellent':
      return 'badge-success';
    case 'rejected':
    case 'flagged':
    case 'suspended':
    case 'poor':
      return 'badge-danger';
    case 'pending':
    case 'requested':
    case 'submitted':
    case 'average':
      return 'badge-warning';
    case 'processing':
    case 'good':
      return 'badge-info';
    default:
      return 'badge-neutral';
  }
};

// Canonical "National / no specific state" label — renamed from "ఆల్ ఇండియా"
// (All India) to "జాతీయం" (National). Older rows/UI may still carry the old
// Telugu spelling (either script variant), the English form, or the internal
// 'all_india' sentinel used on most existing rows — treat all as equivalent
// when comparing, but always write the canonical జాతీయం form going forward.
export const ALL_INDIA_STATE = 'జాతీయం';
export const INTERNATIONAL_STATE = 'అంతర్జాతీయం';

export const isAllIndiaState = (s) => {
  const t = (s || '').trim();
  return t === 'జాతీయం' || t === 'ఆల్ ఇండియా' || t === 'అల్ ఇండియా' || t === 'All India' || t === 'all_india';
};

export const isInternationalState = (s) => {
  const t = (s || '').trim().toLowerCase();
  return t === 'అంతర్జాతీయం' || t === 'అంతర్జాతీయ' || t === 'international';
};

// True if two state strings refer to the same state, tolerating the
// అల్ / ఆల్ "All India" and International spelling variants.
export const statesMatch = (a, b) => {
  const ta = (a || '').trim();
  const tb = (b || '').trim();
  if (ta === tb) return true;
  if (isAllIndiaState(ta) && isAllIndiaState(tb)) return true;
  if (isInternationalState(ta) && isInternationalState(tb)) return true;
  return false;
};

// Normalizes any old "All India" / "International" spelling to the current label for display.
export const displayState = (s) => {
  if (isAllIndiaState(s)) return ALL_INDIA_STATE;
  if (isInternationalState(s)) return INTERNATIONAL_STATE;
  return s;
};

export const formatDateTime = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '-';
  
  return date.toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
};

export const getArticleWebsiteUrl = (article) => {
  if (!article) return '';
  const baseUrl = (process.env.REACT_APP_WEBSITE_URL || 'https://www.udayamdigital.com').replace(/\/+$/, '');
  const identifier = article.slug ? encodeURI(article.slug) : article.id;
  return identifier ? `${baseUrl}/${identifier}` : baseUrl;
};

